import {
  BaseActionType,
  GET_USER_PERMISSIONS_SUCCESS,
} from '../actions/actionTypes'

import { UserPermissionsState } from './initialState'

const initialStateLocalAccessKeysUserPermissions: UserPermissionsState | null =
  null

export function getUserPermissionsReducer(
  state = initialStateLocalAccessKeysUserPermissions,
  action: BaseActionType,
): UserPermissionsState | null {
  if (action.type === GET_USER_PERMISSIONS_SUCCESS)
    return action.payload as UserPermissionsState

  return state
}
